import { Spin } from 'antd';
import styled from 'styled-components';

export const Loader = styled(Spin)`
  color: #1890ff;
`;

export default Loader;
